var map = {
	"./PM_2.2.2.png": 75855,
	"./PM_2.3.2.png": 53,
	"./PM_3.2.2.png": 93579,
	"components/Catalog/P/img/glass/pr/prPlusPerBronze/PM_2.2.2.png": 75855,
	"components/Catalog/P/img/glass/pr/prPlusPerBronze/PM_2.3.2.png": 53,
	"components/Catalog/P/img/glass/pr/prPlusPerBronze/PM_3.2.2.png": 93579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47296;